<template lang="pug">
div
    div.row
        div.col-xs-9
            small.pull-right Subtotal
        div.col-xs-3
           small.pull-right {{ amountFormatted }}

    //- Discount list
    div.row(v-for="discount in discounts")
        div.col-xs-9
            div.pull-right.text-right
                small {{ discount.name }}
                small.block.text-muted(v-if="discount.remarks !== ''") {{ discount.remarks }}
        div.col-xs-3
            small.pull-right {{ discount.amount }}

    //- Total after discount
    div.row(v-if="hasDiscount")
        div.col-xs-9
            small.pull-right After Discount
        div.col-xs-3
            small.pull-right {{ totalAfterDiscount }}

    //- charges
    div.row(v-for="charge in chargesFormatted")
        div.col-xs-9
            small.pull-right {{ charge.charge.name }}
        div.col-xs-3
            small.pull-right {{ charge.amountFormatted }}

    //- taxes
    div.row(v-for="tax in taxesFormatted")
        div.col-xs-9
            small.pull-right {{ tax.tax.name }} ({{ tax.tax_disc }}%)
        div.col-xs-3
            small.pull-right {{ tax.amountFormatted }}

    //- rounding
    div.row
        div.col-xs-9
            small.pull-right Rounding
        div.col-xs-3
            small.pull-right {{ receipt.rounding }}

    //- grand total
    div.row.text-md
        div.col-xs-9
            small.pull-right.grand-total-label Grand Total
        div.col-xs-3.grand-total-amount
            small.pull-right {{ totalAmountFormatted }}

    //- payments
    div.row(v-for="payment in payments")
        div.col-xs-9
            small.pull-right(v-if="payment.reference_number == null") {{ payment.name }}
            small.pull-right(v-else) {{ payment.name }} ({{ payment.reference_number }})
        div.col-xs-3
            small.pull-right {{ payment.amount }}

    //- change
    div.row
        div.col-xs-9
            small.pull-right Change
        div.col-xs-3
            small.pull-right {{ totalChangeFormatted }}
</template>

<script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters, mapActions } from 'vuex';

export default {
    mixins: [receiptMixin],

    computed: {
        ...mapGetters('transaction', [
            'receipt',
            'discounts',
            'totalDiscount',
            'totalAfterDiscount',
            'amountFormatted',
            'totalAmountFormatted',
            'charges',
            'taxes',
            'totalChange',
            'payments',
            'taxesFormatted',
            'chargesFormatted',
            'totalChangeFormatted',
        ]),

        hasDiscount() {
            return this.discounts.length > 0;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt/amount.vue